import { render, staticRenderFns } from "./renkou.vue?vue&type=template&id=0cb7099c&"
import script from "./renkou.vue?vue&type=script&lang=ts&"
export * from "./renkou.vue?vue&type=script&lang=ts&"
import style0 from "./renkou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports